import { DataAccessPolicy } from '@mtna/pojo-consumer-ts';

export class RdsDataAccessPolicyDialogData {
  /**
   * Creates an RdsDataAccessPolicyDialogData object
   * @param dataAccessPolicy the data access policy to display
   * @param mode the mode to display the dialog in
   * @param disableNavigation whether to disable navigation when the user agrees to the policy
   */
  constructor(public dataAccessPolicy: DataAccessPolicy, public mode: 'VIEW' | 'EDIT' | 'INIT', public disableNavigation: boolean) {}
}
